import React from "react";
import { useNavigate } from "react-router-dom";

const WinnerScreen = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center px-4">
      <h1 className="text-5xl font-bold text-purple-600 mb-6">You're the Pokemon Master! 🎉</h1>
      <p className="text-xl text-gray-600 mb-6">Congratulations! You've caught all 151 Pokemon!</p>
      <div className="aspect-video max-w-3xl mx-auto mb-6 rounded-lg overflow-hidden shadow-2xl">
        <iframe
          className="w-full h-full"
          src={`https://www.youtube.com/embed/rg6CiPI6h2g?autoplay=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Pokemon Theme Song"
        />
      </div>
      <button
        onClick={() => navigate("/")}
        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg transition-colors"
      >
        Back to Portfolio
      </button>
    </div>
  );
};

export default WinnerScreen;
